import { useEffect } from 'react';
import { DatadogRUMService } from 'src/services/datadog/DatadogRUMService';

export const usePageCannotLoadState = <TError extends Error | null, TContext extends object | undefined>({
    error,
    context,
}: {
    error: TError;
    context: TContext;
}) => {
    useEffect(() => {
        if (error) {
            DatadogRUMService.Client.getInstance().addError(error, context);
        }
    });
};
